import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-control-button" }

import { ref } from 'vue'

interface Props {
  text: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextControlButton',
  props: {
    text: null
  },
  setup(__props: any) {


const toggleHovered = ref(false)




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "text-control-button__icon",
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (toggleHovered.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (toggleHovered.value = false))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 32),
    _createElementVNode("span", {
      class: _normalizeClass(['text-control-button__text', { 'text-control-button__text--hovered' : toggleHovered.value }])
    }, _toDisplayString(__props.text), 3)
  ]))
}
}

})